import React from 'react';

const WelcomeMessage = ({ message = 'How can I help you today?' }) => {
  return (
    <div className="welcome-message">
      <h2>{message}</h2>
    </div>
  );
};

export default WelcomeMessage;
